<div [id]="id()" [style.height]="height()" class="w-full overflow-x-auto h-full" style="scrollbar-width: none;">
    <div [attr.data-testid]="headerRowId()" *ngIf="headerStatic()">
        <datiq-table-row
            class="w-full flex border-b border-t-0 border-r-0 border-l-0 border-solid border-dat-grey-200"
            [settings]="headerRow()"
            (sortedColumn)="sortColumn($event)"
            (actionFired)="actionFired.emit($event)"
            (selectChanged)="selectChanged.emit($event)"
        ></datiq-table-row>
    </div>
    <cdk-virtual-scroll-viewport
        [itemSize]="itemSize()"
        [style.height.px]="height()"
        class="overflow-x-hidden w-full"
        [attr.data-styletarget]="'table-virtual-scroll-' + id()"
    >
        <div [attr.data-testid]="headerRowId()" *ngIf="!headerStatic()">
            <datiq-table-row
                class="w-full flex border-b border-t-0 border-r-0 border-l-0 border-solid border-dat-grey-200"
                [settings]="headerRow()"
                (sortedColumn)="sortColumn($event)"
                (actionFired)="actionFired.emit($event)"
                (selectChanged)="selectChanged.emit($event)"
            ></datiq-table-row>
        </div>
        <div
            *cdkVirtualFor="let row of ds; let i = index"
            [attr.data-testid]="row?.id"
        >
            <datiq-table-row
                class="w-full flex border-b border-t-0 border-r-0 border-l-0 border-solid border-dat-grey-100 h-auto items-center"
                [ngClass]="{ 'hover:bg-dat-grey-050 cursor-pointer': this.tableSig()?.interactive }"
                [settings]="row"
                [rows]="row"
                (actionFired)="actionFired.emit($event)"
                (rowClicked)="handleRowClick(row)"
                (selectChanged)="selectChanged.emit($event)"
            ></datiq-table-row>
        </div>
    </cdk-virtual-scroll-viewport>
</div>
